import arrowleft from '@features/assignments/assets/arrow-left-black.svg';
import arrowright from '@features/assignments/assets/arrow-right-black.svg';
import assignmentsStyles from '@features/assignments/styles/assignment.module.scss';

interface IAssignmentCalendarHeaderProps {
  weekLess: () => void;
  weekPlus: () => void;
  week: string[];
  todayDate: () => string;
}

export const AssignmentCalendarHeader = ({ weekLess, weekPlus, week, todayDate }: IAssignmentCalendarHeaderProps) => {

  return (
    <div className={assignmentsStyles["assigncalenheader"]}>
      {/* Sección izquierda: Info del usuario */}
      <div className={assignmentsStyles["assigncalenheader__user-section"]}>
        <div className={assignmentsStyles["assigncalenheader__members"]}>
          Miembros
        </div>
        <div className={assignmentsStyles["assigncalenheader__space"]}>% Realizado</div>
        <div className={assignmentsStyles["assigncalenheader__arrow-left"]}>
          <button className={assignmentsStyles["assigncalenheader__arrow-arrow"]} onClick={weekLess}>
            <img src={arrowleft} alt="arrow left" />
          </button>
        </div>
      </div>

      {/* --- Columna derecha: Días y Totales --- */}
      <div className={assignmentsStyles["assigncalenheader__right-col"]}>
        {/* Sección central: Días de la semana */}
        <div className={assignmentsStyles["assigncalenheader__days-section"]}>
          <div className={`${assignmentsStyles["assigncalenheader__day"]} ${todayDate() === week[0].substring(8, 10) ? 'is-today' : ''}`}>
            <span>L</span>
            <span>{week[0].substring(8, 10)}</span>
          </div>
          <div className={`${assignmentsStyles["assigncalenheader__day"]} ${todayDate() === week[1].substring(8, 10) ? 'is-today' : ''}`}>
            <span>M</span>
            <span>{week[1].substring(8, 10)}</span>
          </div>
          <div className={`${assignmentsStyles["assigncalenheader__day"]} ${todayDate() === week[2].substring(8, 10) ? 'is-today' : ''}`}>
            <span>M</span>
            <span>{week[2].substring(8, 10)}</span>
          </div>
          <div className={`${assignmentsStyles["assigncalenheader__day"]} ${todayDate() === week[3].substring(8, 10) ? 'is-today' : ''}`}>
            <span>J</span>
            <span>{week[3].substring(8, 10)}</span>
          </div>
          <div className={`${assignmentsStyles["assigncalenheader__day"]} ${todayDate() === week[4].substring(8, 10) ? 'is-today' : ''}`}>
            <span>V</span>
            <span>{week[4].substring(8, 10)}</span>
          </div>
          <div className={`${assignmentsStyles["assigncalenheader__day_end"]} ${todayDate() === week[5].substring(8, 10) ? 'is-today' : ''}`}>
            <span>S</span>
            <span>{week[5].substring(8, 10)}</span>
          </div>
          <div className={`${assignmentsStyles["assigncalenheader__day_end"]} ${todayDate() === week[6].substring(8, 10) ? 'is-today' : ''}`}>
            <span>D</span>
            <span>{week[6].substring(8, 10)}</span>
          </div>
        </div>

        {/* Sección derecha: Totales y navegación */}
        <div className={assignmentsStyles["assigncalenheader__totals-section"]}>
          <div className={assignmentsStyles["assigncalenheader__sum"]}>TOTAL ESTIMADO</div>
          <div className={assignmentsStyles["assigncalenheader__sum"]}>TOTAL EJECUTADO</div>
          <div className={assignmentsStyles["assigncalenheader__arrow-right"]}>
            <button className={assignmentsStyles["assigncalenheader__arrow-arrow"]} onClick={weekPlus}>
              <img src={arrowright} alt="arrow right" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
